<template>
  <Base>
    <template v-slot:toolbar>
      <div class="toolbar" id="kt_toolbar">
        <div class="container-fluid d-flex flex-stack" id="kt_toolbar_container">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{name: 'dashboard'}" class="text-muted text-hover-primary">
                    <i class="fad fa-home"></i>
                    {{ trans('Dashboard') }}
                  </router-link>
                </li>
              </ul>
            </slot>
          </div>

          <div class="d-flex align-items-center py-1">
            <div class="d-flex align-items-center">
              <div class="btn btn-icon btn-light-danger btn-xs me-2" @click="resetSearch()">
                <i class="fad fa-trash"></i>
              </div>

              <date-range-picker ref="picker" :opens="'left'" :locale-data="localData" :singleDatePicker="false"
                                 :autoApply="false" :ranges="ranges" @update="load" :timePicker="false"
                                 :showWeekNumbers="true"
                                 :showDropdowns="true" v-model="interval">
                <template v-slot:input="picker" style="min-width: 350px;">
                  <template>
                    {{ readableDate(picker.startDate, 'dmY') }} ❖ {{ readableDate(picker.endDate, 'dmY') }}
                  </template>
                </template>
              </date-range-picker>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:content>
      <InsuranceDashboard :interval="interval" @period="applyPeriod"></InsuranceDashboard>
    </template>
  </Base>
</template>
<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import Base from "@/layouts/Base.vue";
import InsuranceDashboard from "@/views/Dashboard/InsuranceDashboard.vue";
import CONSTANTS from "@/Utils/constant";
import DateRangePicker from "vue2-daterange-picker";
import store from "@/store";

@Component({
  components: {InsuranceDashboard, Base, DateRangePicker}
})
export default class PartnerHome extends Vue {
  // Periode glissante : le mois en cours affiche un dashboard vide les premiers jours du mois.
  interval = CONSTANTS.dateConstants.last_30_days()

  localData = {
    direction: 'ltr',
    format: 'mm/dd/yyyy',
    separator: ' - ',
    applyLabel: 'Valider',
    cancelLabel: 'Annuler',
    weekLabel: ' ',
    customRangeLabel: 'Custom Range',
    daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Aout', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    firstDay: 0
  }
  ranges: any = false;

  resetSearch() {
    this.interval = CONSTANTS.dateConstants.last_30_days()
    let def: any = localStorage.getItem('partnerDashboardFilter')
    if (def) {
      def = JSON.parse(def)
      if (def.startDate && def.endDate) {
        this.interval = {startDate: new Date(def.startDate), endDate: new Date(def.endDate)}
      }
    }
    this.ranges = store.getters.loadRanges()
  }

  beforeMount() {
    this.resetSearch()
  }

  /** Depuis le dashboard, quand la periode selectionnee ne contient aucune production. */
  applyPeriod(period: any) {
    this.interval = period
    this.load()
  }

  /** Le dashboard recharge via son watch sur `interval` : on memorise juste la periode. */
  async load() {
    localStorage.setItem('partnerDashboardFilter', JSON.stringify(this.interval))
  }
}
</script>
